// extracted by css-extract-rspack-plugin
export default {"UpsellPillComponent":"K7_9k"};